import { ReactNode, VFC } from 'react'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import { _profilegreen } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

type SectionProps = {
  title: string
  description?: ReactNode
  children: ReactNode
  className?: string
}

export const Section: VFC<SectionProps> = ({
  title,
  description,
  children,
  className,
}) => (
  <Layout className={className}>
    <MessageDiv>
      <h2>{title}</h2>
      {description}
    </MessageDiv>
    {children}
  </Layout>
)

const Layout = styled.section`
  width: 100%;
  padding-bottom: 100px;
`
const MessageDiv = styled.div`
  margin: 0 auto;
  text-align: center;
  font-weight: ${fontWeightBold};
  line-height: 1.5;
  padding: 0 20px;
  h2 {
    font-size: 26px;
    margin-bottom: 40px;
  }
  a {
    color: ${_profilegreen};
  }
  p {
    white-space: pre-wrap;
  }
`
